export default __webpack_public_path__ + "static/media/Amper_photo_06.e62410bb.jpg";